import axios from 'axios';
import type {
  SubmitActivityRequest,
  ActivityStatusResponse,
  SubmitActivityResponse,
} from '../types/activity';

const ACTIVITY_URL = process.env.REACT_APP_ACTIVITY_URL; // event /activity 基底

/** 查詢使用者是否已填寫本活動（後端以 accessToken 取 lineId 判斷） */
export const getActivityStatus = async (
  accessToken: string,
): Promise<ActivityStatusResponse> => {
  const res = await axios.get(`${ACTIVITY_URL}/status`, {
    params: { access_token: accessToken },
  });
  return res.data;
};

/** 送出活動填寫 */
export const submitActivity = async (
  payload: SubmitActivityRequest,
): Promise<SubmitActivityResponse> => {
  const res = await axios.post(`${ACTIVITY_URL}/submit`, payload);
  return res.data;
};
